import { GraphGradientMode } from '../uPlot/config';
/**
 * @alpha
 */
export var BarStackingMode;
(function (BarStackingMode) {
    BarStackingMode["None"] = "none";
    BarStackingMode["Standard"] = "standard";
    BarStackingMode["Percent"] = "percent";
})(BarStackingMode || (BarStackingMode = {}));
/**
 * @alpha
 */
export var BarValueVisibility;
(function (BarValueVisibility) {
    BarValueVisibility["Auto"] = "auto";
    BarValueVisibility["Never"] = "never";
    BarValueVisibility["Always"] = "always";
})(BarValueVisibility || (BarValueVisibility = {}));
/**
 * @alpha
 */
export var defaultBarChartFieldConfig = {
    lineWidth: 1,
    fillOpacity: 80,
    gradientMode: GraphGradientMode.None,
    axisSoftMin: 0,
};
//# sourceMappingURL=types.js.map